import { Injectable } from '@angular/core';
import { Http, Response, Headers, RequestOptions } from '@angular/http';
import { Observable } from "rxjs/Observable";

import * as globalConst from './../../../constants';

@Injectable()
export class EconomicGroupFlowService {

  private apiUrl = globalConst.baseAPI;  // URL para web api  

  constructor(private http: Http) { }

  getEconomicGroupFlows(id) {
    return this.http
      .get(this.apiUrl + "/flowgroup/v1/getgroup?$filter=ClassificacaoGrupoEconomicoId eq " + id + " and Ativo eq true" + "&$orderby=Nivel asc", JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  getEconomicGroupClassifications() {
    return this.http
      .get(this.apiUrl + "/classificationgroup/v1/getclassificationgroup?$filter=Ativo eq true&$orderby=Nivel asc", JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  listProfile() {
    return this.http
      .get(this.apiUrl + "/profile/v1/getprofiles?&$orderby=Descricao asc", JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  insertEconomicGroupFlow(economicGroupFlow) {

    var params = {
      "Nivel": economicGroupFlow.Nivel,
      "PerfilID": economicGroupFlow.Perfil,
      "ClassificacaoGrupoEconomicoId": economicGroupFlow.ClassificacaoGrupoEconomicoId,
      "Ativo": true,
    }

    return this.http
      .post(this.apiUrl + "/flowgroup/v1/insertgroup", params, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json())
      .catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

  deleteEconomicGroupFlow(id) {
    return this.http
      .delete(this.apiUrl + 'flowgroup/v1/inactivegroup/' + id, JSON.parse(localStorage.getItem('yara.connectionHeader')))
      .map((res: Response) => res.json()).catch(e => {
        if (e.status === 401) {
          return Observable.throw('Unauthorized');
        }
      });
  }

}


// WEBPACK FOOTER //
// ./src/app/economic-group-flow/service/economic-group-flow.service.ts